export default __webpack_public_path__ + "static/char-v-21-3d25faa6c82424eff4b7289e658bde04.mp4";